import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

const HomeRedirect: React.FC = () => {
  const { session } = useStore();
  const location = useLocation();

  const redirectTo = session.isAuthenticated ? String(routes.dashboard.home) : routes.login;

  return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />;
};

export default observer(HomeRedirect);
